import React from 'react';
import './hto-customer-details.scss';
import { isName, email, required } from '../../../../utils/validation';
import { Field } from 'react-final-form';
import { composeValidators } from '../../../../utils/helper';

const Radio = ({ input, children, style }) => {
    return (
        <label className="text-center" style={style}><input type="radio" {...input} /> {children}</label>
    );
};

const HTOCustomerDetais = ({ values }) => {
    return (
        <div className="customer-details-container pd-10 pd-b20">
            <h5 className="text-uppercase margin-b10 mr-b10 fsp14 fw500 pd-t10">Customer Details</h5>
            <div className="display-flex customer-details-wrapper justify-space-between">
                <Field name="firstName" validate={composeValidators(required, isName)}>
                    {({ input, meta }) => (
                        <div className="form-group details-group">
                            <label className="fsp14">First Name</label>
                            <input {...input} type="text" className="detail-input form-control" maxLength="200" />
                            <span className="block margin-t4 fs10 mr-t4 fsp10 text-color_brick_red">{meta.error && meta.touched ? meta.error : ''}</span>
                        </div>
                    )}
                </Field>
                <Field name="lastName" validate={composeValidators(required, isName)}>
                    {({ input, meta }) => (
                        <div className="form-group details-group">
                            <label className="fsp14">Last Name</label>
                            <input {...input} type="text" className="detail-input form-control" maxLength="200" />
                            <span className="block margin-t4 fs10 mr-t4 fsp10 text-color_brick_red">{meta.error && meta.touched ? meta.error : ''}</span>
                        </div>
                    )}
                </Field>
                <Field name="email" validate={composeValidators(required, email)}>
                    {({ input, meta }) => (
                        <div className="form-group details-group">
                            <label className="fsp14">Email</label>
                            <input {...input} type="text" className="detail-input form-control" maxLength="200" />
                            <span className="block margin-t4 fs10 mr-t4 fsp10 text-color_brick_red">{meta.error && meta.touched ? meta.error : ''}</span>
                        </div>
                    )}
                </Field>
            </div>
            <div className="display-flex customer-details-wrapper justify-space-between">
                <Field name="addressline1">
                    {({ input, meta }) => (
                        <div className="form-group details-group">
                            <label className="fsp14">Area Name</label>
                            <input {...input} type="text" className="detail-input form-control" maxLength="200" />
                            <span className="block margin-t4 fs10 mr-t4 fsp10 text-color_brick_red">{meta.error && meta.touched ? meta.error : ''}</span>
                        </div>
                    )}
                </Field>
                <Field name="addressline2" validate={required}>
                    {({ input, meta }) => (
                        <div className="form-group details-group">
                            <label className="fsp14">Building Name, Flat Number</label>
                            <input {...input} type="text" className="detail-input form-control" maxLength="200" />
                            <span className="block margin-t4 fs10 mr-t4 fsp10 text-color_brick_red">{meta.error && meta.touched ? meta.error : ''}</span>
                        </div>
                    )}
                </Field>
                <div className="form-group details-group">
                    <label className="fsp14">Save Address as:</label>
                    <div className="display-flex justify-space-between">
                        <Field name="addressType" type="radio" value="home" component={Radio} style={{ margin: 0, marginRight: '5px' }}>
                            <div id="home-address" className={`icons-group address-icon bora-4 ${values.addressType === 'home' ? 'active' : ''}`}><i className="fa fa-home fs16 margin-r5 icon-home" aria-hidden="true"></i> Home</div>
                        </Field>
                        <Field name="addressType" type="radio" value="work" component={Radio} style={{ margin: 0, marginRight: '5px' }}>
                            <div id="work-address" className={`icons-group address-icon bora-4 ${values.addressType === 'work' ? 'active' : ''}`}><i className="fa fa-briefcase fs16 margin-r5 icon-shopping-bag" aria-hidden="true"></i> Work</div>
                        </Field>
                        <Field name="addressType" type="radio" value="other" component={Radio} style={{ margin: 0 }}>
                            <div id="other-address" className={`icons-group address-icon bora-4 ${values.addressType === 'other' ? 'active' : ''}`}><i className="fa fa-book fs16 margin-r5 icon-book" aria-hidden="true"></i> Other</div>
                        </Field>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HTOCustomerDetais;
